
export enum FreebiesCategoryEnum {
    BREAKFAST = 1,
    MEALS = 2,
    TEABREAK = 3,
    SNACKS = 4 
}